/**
 * "Make one like this for you" (trial14-and-demo handoff §2, 2026-10-12): straight to building,
 * with the plan's default features and look — the plan screen presses its own "Looks good — build
 * it" once the plan is ready. Asked for here, by the demo screen, and taken once there.
 *
 * sessionStorage, one tab, and short-lived: a plan reached later by another way is never built
 * by itself.
 */
const KEY = 'saddle.autoBuild';
const WITHIN_MS = 3 * 60 * 1000;

export function markAutoBuild(): void {
  try {
    sessionStorage.setItem(KEY, String(Date.now()));
  } catch {
    /* without it, the plan simply waits for its button */
  }
}

/** True once, within a few minutes of the press that asked for it; then forgotten. */
export function takeAutoBuild(): boolean {
  try {
    const at = Number(sessionStorage.getItem(KEY));
    sessionStorage.removeItem(KEY);
    return Number.isFinite(at) && at > 0 && Date.now() - at < WITHIN_MS;
  } catch {
    return false;
  }
}
